import 'primeflex/primeflex.css'
import 'primeicons/primeicons.css'
import 'primereact/resources/primereact.min.css'
// import 'primereact/resources/themes/vela-orange/theme.css'
import 'primereact/resources/themes/tailwind-light/theme.css'
// import 'react-device-frameset/dist/styles/marvel-devices.min.css'
// import 'react-device-frameset/dist/styles/device-emulator.css'
import React from 'react'
import * as Sentry from '@sentry/react'
import { createRoot } from 'react-dom/client'
import {
  BrowserRouter,
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom'
import App from './App'
import reportWebVitals from './reportWebVitals'
import './index.scss'
import ScrollToTop from './ScrollToTop'
import './i18n'

Sentry.init({
  dsn: 'https://c7f1e7125ce1013bce33cf468b6eb5fd@o4508619361550336.ingest.de.sentry.io/4508619365482576',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],
  release: '1.0.0',
  normalizeDepth: 10,
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
})

const container = document.getElementById('root')!
if (!container) throw new Error('Failed to find the root element')
const root = createRoot(container)

root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <ScrollToTop />
    <App />
  </BrowserRouter>,
  // </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
